import { Check, Minus } from '@phosphor-icons/react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import cls from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';
import styles from './styles.module.scss';

type CheckedState = boolean | 'indeterminate';

export interface CheckboxProps
    extends Omit<
        ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
        'checked' | 'defaultChecked' | 'onCheckedChange'
    > {
    checked: CheckedState;
    onCheckedChange: (checked: CheckedState) => void;
}

/**
 * Shared Bustly checkbox for admin selection and settings controls.
 * Supports the indeterminate state used by grouped selections.
 */
export const Checkbox = ({
    checked,
    onCheckedChange,
    className,
    ...props
}: CheckboxProps) => (
    <CheckboxPrimitive.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={cls(styles.root, className)}
        {...props}
    >
        <CheckboxPrimitive.Indicator className={styles.indicator}>
            {checked === 'indeterminate' ? (
                <Minus size={12} weight="bold" aria-hidden="true" />
            ) : (
                <Check size={12} weight="bold" aria-hidden="true" />
            )}
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
);
